import React, { JSX, useEffect, useState } from 'react';

import { Col, Cols, Span, Text, TextButton, TKey } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

export interface IDashboardCrumb {
  // group by key
  sourceLabel: string;
  // specific item name that has been drilled into
  itemLabel: string;
  tKey?: TKey;
}

interface IDashboardBreadCrumbs {
  initialMessage?: string;
  items: IDashboardCrumb[];
  onClick: (index: number) => void;
  initialMessageTKey?: TKey;
}

export const DashboardBreadCrumbs = ({
  initialMessage = '',
  items = [],
  onClick,
  initialMessageTKey,
}: IDashboardBreadCrumbs): JSX.Element => {
  const [isTipDisplayed, setIsTipDisplayed] = useState(true);

  useEffect(() => {
    if (items.length > 0) {
      setIsTipDisplayed(false);
    }
  }, [items]);

  return (
    <>
      {isTipDisplayed ? (
        <Cols
          style={{
            padding: '8px 16px',
            backgroundColor: publicaColors.veryLightGray,
            borderRadius: '4px',
            marginTop: '16px',
            alignItems: 'center',
          }}
        >
          <Col style={{ paddingRight: '8px' }}>
            <img src='/assets/shared/svg/LightBulb.svg' />
          </Col>
          <Col>
            <Text tKey={initialMessageTKey}>{initialMessage}</Text>
          </Col>
        </Cols>
      ) : (
        <Cols
          style={{
            marginTop: items.length > 0 ? '16px' : '0px',
            padding: '0px 16px',
          }}
        >
          {items.map((item, i) => (
            <>
              <Col>
                <Text>
                  <TextButton onClick={() => onClick(i)}>
                    <Span color={publicaColors.darkBlue} bold tKey={item.tKey}>
                      {item.sourceLabel}
                    </Span>
                  </TextButton>
                  <Span style={{ padding: '0px 4px' }}>/</Span>
                </Text>
              </Col>
              <Col>
                <Text>
                  {item.itemLabel}
                  {i < items.length - 1 && <Span style={{ padding: '0px 4px' }}>/</Span>}
                </Text>
              </Col>
            </>
          ))}
        </Cols>
      )}
    </>
  );
};
